import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import QROIAdmin from "./components/QROIAdmin/QROIAdmin";

const domNode = document.getElementById("root");
const root = createRoot(domNode);
root.render(<QROIAdmin />);
